<style>
    .v-application--wrap {
        background-color: #e1e1e1;
    }
</style>
<template>
    <v-container class="m-sm-0 p-sm-0">
        <v-row justify="center" class="mt-lg-5 mt-sm-0">
            <v-col lg="4" md="6" sm="12">
                <v-card flat outlined elevation="10" v-show="!waitingForfResp && !hasAuthorizationError" :loading="loggingIn">
                    <template slot="progress">
                        <v-progress-linear color="success" indeterminate></v-progress-linear>
                    </template>
                    <v-card-title class="pb-0 justify-center">
                        <v-img max-height="150"
                               max-width="150"
                               src="https://mwidirect.com/wp-content/uploads/2018/02/MWI-Direct-RGB-e1518822688345.png"></v-img>
                    </v-card-title>
                    <v-card-title class="header justify-center" >
                        Customer Login Portal
                    </v-card-title>
                    <v-card-actions class="mx-auto mt-2" v-show="!loginSuccess">
                        <v-card-text class="text-center">
                            <v-expand-transition>
                                <v-icon large color="#D50000">mdi-cancel</v-icon>
                            </v-expand-transition>    <b style="color :#D50000 !important"> Iogin Failed/Invalid Username or Password</b>
                        </v-card-text>
                    </v-card-actions>
                    <v-card-text>
                        <validation-observer ref="observer">
                            <v-form @submit.prevent="submit">
                                <validation-provider v-slot="{ errors }" name="Username" rules="required">
                                    <v-text-field label="Username"
                                                  v-model="userName"
                                                  required
                                                  :error-messages="errors"
                                                  prepend-icon="mdi-account-circle" />
                                </validation-provider>
                                <validation-provider v-slot="{ errors }" name="password" rules="required">
                                    <v-text-field label="Password"
                                                  prepend-icon="mdi-lock"
                                                  v-model="password"
                                                  :error-messages="errors"
                                                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                                  @click:append="showPass = !showPass"
                                                  :type="showPass ? 'text' : 'password'"
                                                  required />
                                </validation-provider>
                                <v-card-actions class="mt-4">
                                    <v-btn color="black" block type="submit" :disabled="loggingIn" outlined>
                                        {{ActionText}}
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                        </validation-observer>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { required, email } from 'vee-validate/dist/rules';
    import { extend } from 'vee-validate';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    /* eslint-disable no-useless-escape , vue/no-unused-components*/
    //Exporting this so it can be used in other components

  extend('required', required);
  extend('email', email);

export default {
        components: {
        ValidationProvider,
        ValidationObserver,
        }, inject: {
            theme: {
                default: { isDark: false },
            },
        },
  data: () => ({
    userName: '',
    ActionText:'Login',
    password: null,
    showPass: false,
    isAuthorized: false,
    hasAuthorizationError: false,
    waitingForfResp: false,
    stateData: '',
    loggingIn: false,
    loginSuccess: true
        }),
  computed: {
    params() {
      return {
        userName: this.userName,
        password: this.password
      }
    }
  },
        methods: {
            RestForm: function () {
                this.waitingForfResp = false;
                this.loggingIn = false;
                this.hasAuthorizationError = false;
                this.isAuthorized = false;
            },
    
      async submit() {
               
      var self = this;
      const valid = await this.$refs.observer.validate()
      if (valid) {
      //this.login(this.params) // action to login
      self.ActionText = 'Signing In...'
      self.loggingIn = true;
      self.loginSuccess = true;
      await this.$http.post('/Auth/SignIn', { UserName: self.userName, Password: self.password}).then(function (response) {
              if (response.data.success) {
                  self.stateData = {
                      token: response.data.tokenization.token,
                      userName: self.userName,
                      customerModules: response.data.customerModules,
                      currentCustomer: response.data.customerModules[0].customerInfo
                  };

                  self.isAuthorized = true;
                  self.$store.commit('SetAuth', self.stateData);
                  self.waitingForfResp = false;

                  if (response.data.customerModules.length == 1) {
                      self.$router.push(
                          {
                              name: response.data.customerModules[0].routerLink,
                              query: {
                                  modulekey: response.data.customerModules[0].moduleKey
                              }
                          })
                  }
                  else {
                      self.$router.push('Home')
                  }
              }
              else {
                  self.loginSuccess = false;
                  self.loggingIn = false
                  self.password = '';
                  self.$refs.observer.reset()
                   self.ActionText = 'Login'
              }
          })
       }
    },
    clear() {
      // you can use this method to clear login form
      this.userName = ''
      this.password = null
      this.$refs.observer.reset()
    }
  }
}
</script>